import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * White play circle with the triangle knocked out, so the thumbnail shows
 * through. Decorative: the card's Watch control carries the accessible name.
 */
PlayCircle.propTypes = {
  size: PropTypes.oneOf(['md', 'lg'])
};

export function PlayCircle(props) {
  const { size = 'md' } = props;
  const maskId = `play-${useId().replace(/:/g, '')}`;

  return (
    <svg
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
      className={classNames(
        'text-white drop-shadow transition-[width,height] duration-200',
        size === 'lg' ? 'size-[50px] group-hover:size-[55px]' : 'size-10 group-hover:size-11'
      )}
    >
      <defs>
        <mask id={maskId}>
          <rect width="40" height="40" fill="white" />
          <path d="M16.5 14L26.5 20L16.5 26Z" fill="black" stroke="black" strokeWidth="2.5" strokeLinejoin="round" />
        </mask>
      </defs>
      <circle cx="20" cy="20" r="20" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
}

/** 72px blue tile with a play triangle, used by the compact row cards. */
export function PlayTile() {
  return (
    <div
      className="size-[72px] flex-shrink-0 rounded-[10px] bg-cs-blue-50 flex items-center justify-center pl-1.5"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 16 20"
        focusable="false"
        className="w-4 h-5 text-cs-blue-400"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      >
        <path d="M2 2L14 10L2 18Z" />
      </svg>
    </div>
  );
}
